import clsx from 'clsx';
import { Checkbox } from '@/components/ui';

export interface TeamExclusionCheckboxProps {
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
}

export function TeamExclusionCheckbox({
  label,
  checked,
  onCheckedChange,
  className,
}: TeamExclusionCheckboxProps) {
  return (
    <div className={clsx('shrink-0', className)}>
      <Checkbox
        label={label}
        checked={checked}
        onChange={(event) => onCheckedChange(event.target.checked)}
      />
    </div>
  );
}
